import { render, staticRenderFns } from "./desposit-payment.vue?vue&type=template&id=2278d5d2&"
import script from "./desposit-payment.vue?vue&type=script&lang=js&"
export * from "./desposit-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports